// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"d718fa8a","570":"992cffb0","843":"106e6edb"}[chunkId] + ".chunk.js";
};